import { CheckoutLocale } from '@platform-frontend/checkout-drop-in';

export interface LocaleStartParams {
  locale: CheckoutLocale | null;
}
